var map = {
	"./apartment.svg": 481,
	"./bungalow.svg": 4162,
	"./cabin.svg": 4166,
	"./farmhouse.svg": 2944,
	"./hotel.svg": 6293,
	"./house.svg": 4873,
	"./room.svg": 207,
	"./townhome.svg": 9083,
	"./warehouse.svg": 5156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8285;